module.exports = __webpack_public_path__ + "static/call-to-action-rivvit-supports-data-elements-82409b638806443c6c6ff199901fb5d9.jpg";